import React from "react";
import DelegateButton from "@components/FlowActionButtons/DelegateButton";
import type { Task } from "@services/vesselCall/types";

interface DelegateVesselCallProps {
  vesselCallFlowData?: {
    vesselCallId: string;
    task: Task | null;
    status: string;
  };
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const DelegateVesselCall: React.FC<DelegateVesselCallProps> = ({ vesselCallFlowData }) => {
  if (!vesselCallFlowData) {
    return null;
  }
  const isActionAvailable = false; // this is to be refined
  const handleDelegateClick = () => {
    console.log(vesselCallFlowData?.vesselCallId);
  };

  return (
    <DelegateButton
      langBase={LANG_BASE}
      permission="canDelegateVesselCall"
      isActionAvailable={isActionAvailable}
      onDelegate={handleDelegateClick}
    />
  );
};
export default DelegateVesselCall;
